import React from "react";
import { Link } from "react-router-dom";
import "./Button.css";

function Button() {
  return (
    <Link to="customer">
      <button className="btn">BECOME A CUSTOMER</button>
    </Link>
  );
}

export default Button;
